import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { ClientModel, AbstractPost } from "@devowl-wp/utils";
import { request } from "../utils";
import { action, computed, observable, reaction, runInAction } from "mobx";
import { TcfVendor } from "./tcfVendor";
import $ from "jquery";
class TcfVendorConfigurationModel extends AbstractPost {
    get restrictivePurposes() {
        var _this_vendorModel;
        const result = JSON.parse(this.data.meta.restrictivePurposes);
        // Merge with original vendor purposes so all are listed
        return $.extend(true, {}, ((_this_vendorModel = this.vendorModel) == null ? void 0 : _this_vendorModel.restrictivePurposes) || {}, result);
    }
    get dataProcessingInCountries() {
        return JSON.parse(this.data.meta.dataProcessingInCountries || "[]");
    }
    get dataProcessingInCountriesSpecialTreatments() {
        return JSON.parse(this.data.meta.dataProcessingInCountriesSpecialTreatments || "[]");
    }
    constructor(collection, data = {}){
        super(collection, data);
        reaction(()=>this.data.vendor, (vendor)=>runInAction(()=>{
                if (vendor) {
                    const { vendors } = this.collection.store;
                    const vendorId = vendor.id.toString();
                    let existing = vendors.get(vendorId);
                    if (!existing) {
                        existing = new TcfVendor(vendor, this.collection.store);
                        vendors.set(vendorId, existing);
                    }
                    this.vendorModel = existing;
                }
            }), {
            fireImmediately: true
        });
        // Automatically set the vendor model (e.g. newly saved configuration)
        reaction(()=>{
            var _this_data_meta;
            return (_this_data_meta = this.data.meta) == null ? void 0 : _this_data_meta.vendorId;
        }, (vendorId)=>{
            if (vendorId) {
                this.vendorModel = this.collection.store.vendors.get(vendorId.toString());
            }
        }, {
            fireImmediately: true
        });
    }
    setStatus(status) {
        this.data.status = status;
    }
    setMeta(meta) {
        this.data.meta = meta;
    }
    transformDataForPatch() {
        const data = super.transformDataForPatch();
        return {
            status: data.status,
            meta: data.meta
        };
    }
    afterPatch() {
        this.collection.store.rootStore.optionStore.fetchCurrentRevision();
    }
    afterDelete() {
        this.collection.store.rootStore.optionStore.fetchCurrentRevision();
    }
    afterPersist() {
        this.collection.store.rootStore.optionStore.fetchCurrentRevision();
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof TcfVendor === "undefined" ? Object : TcfVendor)
], TcfVendorConfigurationModel.prototype, "vendorModel", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", typeof TcfVendorConfigurationRestrictivePurposes === "undefined" ? Object : TcfVendorConfigurationRestrictivePurposes)
], TcfVendorConfigurationModel.prototype, "restrictivePurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Object)
], TcfVendorConfigurationModel.prototype, "dataProcessingInCountries", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Object)
], TcfVendorConfigurationModel.prototype, "dataProcessingInCountriesSpecialTreatments", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof PostStatus === "undefined" ? Object : PostStatus
    ]),
    _ts_metadata("design:returntype", void 0)
], TcfVendorConfigurationModel.prototype, "setStatus", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], TcfVendorConfigurationModel.prototype, "setMeta", null);
TcfVendorConfigurationModel = _ts_decorate([
    ClientModel.annotate({
        keyId: "id",
        namespace: "wp/v2",
        request,
        create: {
            path: "/rcb-tcf-vendor-conf"
        },
        patch: {
            path: "/rcb-tcf-vendor-conf/:id"
        },
        delete: {
            path: "/rcb-tcf-vendor-conf/:id"
        }
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof Partial === "undefined" ? Object : Partial
    ])
], TcfVendorConfigurationModel);
export { TcfVendorConfigurationModel };
